import React from 'react';
import {withI18n} from '@shopify/react-i18n';

import i18nArgs from '../../locales';

function ProfileContainer({children}: {children: React.ReactNode}) {
  return <>{children}</>;
}

export default withI18n(i18nArgs)(ProfileContainer);
